import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { AttendanceService } from '../../../../_services/attendance/attendance.service'
import { ApprovalService } from "src/app/_services/approval/approval.service";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-regularization-approval',
  templateUrl: './regularization-approval.component.html',
  styleUrls: ['./regularization-approval.component.scss']
})
export class RegularizationApprovalComponent implements OnInit {

  jsonData: any;
  tenantId: string;
  userId: number;
  date: any;
  currentUser: any;
  defaultColDef: any;
  rowSelection: any
  dataSource: any;
  public columnDefs: ColDef[];
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = [];
  private api: GridApi;
  private columnApi: ColumnApi;
  rowData: any;
  getUserName: any;
  isAdmin: boolean;
  isTenantCustomised: boolean;
  isStatus: any;

  constructor(
    private storageService: LocalStorageService,
    private attendanceService: AttendanceService,
    private datepipe: DatePipe,
    private approvalService: ApprovalService,
  ) {
    {
      this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
      };
      this.rowSelection = 'multiple';
      this.columnDefs = this.createColumnDefs();

      this.sampleGridFrameworkComponents = {
        actionRowRendererComponent: ActionItemsGridRowRendererComponent
      };
    }
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.getManualapprovals();

  }

  async getAttendance() {
    let employeeId = this.currentUser.id;
    console.log("current user id:", employeeId);
    this.attendanceService.getAttendanceById(employeeId).subscribe((response: any) => {
      if (response.result && response.result.length > 0) {
        this.rowData = response.result.map(x => ({ ...x, day: this.getDays(x.attendanceDate) }));
      } else {
        this.rowData = [];
      }
    });
  }

  getManualapprovals() {
    let filterType = 'regularization';
    this.approvalService.getApprovals(filterType).subscribe((response: any) => {
      console.log(response, "response")
      this.rowData = response.regularizations;
      if (response.regularizations && response.regularizations.length > 0) {
        this.rowData = response.regularizations.map(x => ({ ...x, day: this.getDays(x.attendanceDate) }));
      } else {
        this.rowData = [];
      }
      //console.log("getUserLeaveApplicationApproval Response", this.rowData);
    });

  }
  /**
  * get day from date
  * @param date 
  */
  getDays(date) {
    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return weekday[new Date(date).getDay()];
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = [];
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data);
    }
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params: any) {
    this.api = params.api;
    console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  private createColumnDefs() {
    return [
      {
        headerName: "Date",
        field: "attendanceDate", 'width': 200,
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Days',
        field: 'day', 'width': 50,
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Emp Id',
        field: 'localId',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Employee',
        field: 'employeeName',
        filter: true,
        editable: false,
        sortable: true,
      },
      {
        headerName: 'InTime : OutTime',
        field: 'inTime', 'width': 220,
        filter: true,
        editable: false,
        sortable: true,
        valueGetter: function (params) {
          return params.data.inTime + " : " + params.data.outTime;
        },
      },
      {
        headerName: 'Working Hours',
        field: 'workTimeInHours',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Time Before Regularization',
        field: 'inTimeWithoutRegularization', 'width': 220,
        filter: true,
        editable: false,
        sortable: true,
        valueGetter: function (params) {
          return params.data.inTimeWithoutRegularization + " : " + params.data.outTimeWithoutRegularization;
        },
      },
      {
        headerName: 'Work Hrs Before Regularization',
        field: 'workTimeInHoursWithoutRegularization',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Action',

        cellRenderer: (params) => {

          if (params.data.inTime != "" && params.data.outTime != "") {
            const spanElement = document.createElement('div');
            spanElement.classList.add('d-flex');
            spanElement.innerHTML = `<button type="button" id="approvalBtn" class="btn btn-success btn-sm" style="margin-right: 5px">Approval</button> <button type="button" id="cancelBtn"class="btn-danger btn-sm btn">Cancel</button>`;
            spanElement.addEventListener('click', ($event) => {

              if ($event.target && $event.target['id'] == "approvalBtn") {
                this.userId = params.data.employeeId;
                this.date = params.data.attendanceDate;
                $event.preventDefault();
                let element: HTMLElement = document.getElementById('confimationBtn');
                element.click();
              } else {
                $event.preventDefault();
                console.log('456');
              }
              if ($event.target && $event.target['id'] == "cancelBtn") {
                this.userId = params.data.employeeId;
                this.date = params.data.attendanceDate;
                $event.preventDefault();
                let element: HTMLElement = document.getElementById('cancelConfirmationBtn');
                element.click();
              } else {
                $event.preventDefault();
                console.log('456');
              }
              // this.router.navigate([this.tenantId + '/dashboard/hr/attendance-detail'], { queryParams: { contactId: params.data.id } });
              //  this.manualLeaves(params.data);
            });
            return spanElement;

          }


        }

      },

    ]
  }

  /**
   * approval leave
   * @param userId 
   */
  approvalLeave(userId: number, date: any) {
    const formatDate = this.datepipe.transform(date, 'dd-MM-yyyy')
    this.approvalService.regularizationsApproval(userId, formatDate).subscribe({
      next: (value) => {
        this.getManualapprovals();
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {

      },
    })
  }

  /**
 * cacel leave
 * @param userId 
 */
  cancelLeave(userId: number, date: any) {
    const formatDate = this.datepipe.transform(date, 'dd-MM-yyyy')
    this.approvalService.regularizationsLeaveCancelById(userId, formatDate).subscribe({
      next: (value) => {
        this.getManualapprovals();
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {

      },
    })
  }

  bulkApproveStatus() {
    const formattedData = this.selectedCheckboxData.map(item => ({
      userId: item.employeeId,
      regularizationDate: item.attendanceDate
    }));
    window.alert("This is a backgroud activity and it will take few seconds, please refresh after sometime.");
    this.approvalService.bulkApproveRegularizations(formattedData).subscribe((response: any) => {
      console.log('Status Updated!!!');
    });
  }

  bulkRejectStatus() {
    const formattedData = this.selectedCheckboxData.map(item => ({
      userId: item.employeeId,
      regularizationDate: item.attendanceDate
    }));
    window.alert("This is a backgroud activity and it will take few seconds, please refresh after sometime.");
    this.approvalService.bulkRejectRegularizations(formattedData).subscribe((response: any) => {
      console.log('Status Updated!!!');
    });
  }
}